import { Fragment, useState } from "react";
import { Card } from "react-bootstrap";
import CardFrame from "./../../Components/layout/CardFrame";
import ProductItemCard from "./../../Components/Home/ProductItemCard";
import DDLmeasurementSettings from "./../../Components/Measurement/DDLmeasurementSettings";
import measurementSettingsDetailsServices from "../../services/measurementSettingsDetailsServices";
import { NotificationManager } from "react-notifications";
import MeasurementSettingShow from "./../Measurement/MeasurementSettingShow";
import { Prev } from "react-bootstrap/esm/PageItem";
import { update_MeasurementSettingsStore } from "./../../slice/orderSlice";
import { useSelector, useDispatch } from "react-redux";

const ProductMeasurementSetting = () => {
  //*** Store */
  const dispatch = useDispatch();
  const { measurementSettings } = useSelector((state) => state.order);

  // measurementSettingsID_GUID
  const [
    selectedMeasurementSettingsID_GUID,
    setSelectedMeasurementSettingsID_GUID,
  ] = useState("");
  // const [lstMeasurementSetting, setLstMeasurementSetting] = useState([]);

  //********************** add product measurement *************** */
  const onProductItemSelect = (
    selectedProductItemGIUD,
    selectedProductItemName,
    slectedID,
    selectedValue,
    makingCharge
  ) => {
    // alert(slectedID + ",vv " + selectedValue);
    // setSelectedMeasurementSettings(slectedID);
    if (slectedID === 0) {
      NotificationManager.warning("Please select an item", "Warning", 4000);
      return;
    }
    setSelectedMeasurementSettingsID_GUID(slectedID);
    fetchMeasurementSettings(slectedID);
  };

  //(a) Get all measurement settings by settings ID(item)
  const fetchMeasurementSettings = async (settingsID) => {
    try {
      let measurementSettingsAll =
        await measurementSettingsDetailsServices.getBySettingsID(settingsID);
      console.log(
        "measurementSettingsAll : " +
          measurementSettingsAll.length +
          ",   " +
          JSON.stringify(measurementSettingsAll[0])
      );

      dispatch(update_MeasurementSettingsStore([]));
      dispatch(update_MeasurementSettingsStore(measurementSettingsAll));

      // setLstMeasurementSetting((prevArray) => [
      //   ...prevArray,
      //   measurementSettingsAll,
      // ]);

      // setArrayOrderDetail([]);
      // setArrayOrderDetail((prevArray) => [...prevArray, props.orderDetailProps]);
    } catch (e) {
      console.error(e);
    }
  };
  //********************** END add product measurement *************** */
  //***   Measurement Setting Detail   */

  //***  Edit OR Delete  ** */
  const delete_MeasurementSettingsDetails = async (guid) => {
    // alert(
    //   "Final - Delete -> delete_MeasurementSettingsDetails => guid: " + guid
    // );

    let result = await measurementSettingsDetailsServices.deleteByGUID(guid);
    if (result != null) {
      //Notification
      NotificationManager.success(
        "Measurement Attribute Saved successfully",
        "Successful!",
        4000
      );
      console.log("result : " + JSON.stringify(result));
    } else {
      //Notification
      NotificationManager.warning("Sorry, remove failed", "Failed!", 4000);
      console.log("result : " + JSON.stringify(result));
    }
  };

  const edit_MeasurementSettingsDetails = (guid, isExtendedNote) => {
    alert(
      "Final - Edit -> edit_MeasurementSettingsDetailsByGUID   111111 => guid:++++ " +
        guid +
        isExtendedNote
    );
  };

  return (
    <Fragment>
      <div
        className="card "
        style={{ marginTop: "10px", marginBottom: "10px", padding: "10px" }}
      >
        <div className="card-body card-body-padding-less">
          <div style={{ float: "left" }}>
            <DDLmeasurementSettings ddlOnSelectFunction={onProductItemSelect} />
          </div>
          <div style={{ clear: "both" }}></div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12">
                  <MeasurementSettingShow
                    lstMeasurementDetail={measurementSettings}
                    selectedMeasurementSettingsID_GUID={
                      selectedMeasurementSettingsID_GUID
                    }
                    edit_MeasurementSettingsDetailsFunc={
                      edit_MeasurementSettingsDetails
                    }
                    delete_MeasurementSettingsDetailsByGUID={
                      delete_MeasurementSettingsDetails
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className="card-title"
                    style={{ marginBottom: "0px", height: "20px" }}
                  >
                    <div style={{ float: "left" }}>
                      {" "}
                      <h4>
                        {measurementSettings[0]?.name} - Measurement Atrributes
                      </h4>
                    </div>
                    <div style={{ float: "right" }}>
                      <button className="btn btn-primary px-3">Add New</button>
                    </div>
                    <div style={{ clear: "both" }}></div>
                    <hr />
                    <div style={{ clear: "both" }}></div>
                  </div>
                  <br /> <br />
                  {/* List Table *}
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>SI</th>
                          <th>Measurement Atrribute Name</th>
                          <th>Row</th>
                          <th>Column</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {measurementSettings
                          .filter((measurementDetail) => {
                            return measurementDetail.isNote === false;
                          })
                          .map((measurement, i) => {
                            return (
                              <tr>
                                <th>{i + 1}</th>
                                <td>{measurement.fieldName}</td>
                                <td>{measurement.rowNo}</td>
                                <td>{measurement.columnNo}</td>
                                <td>
                                  <button
                                    onClick={() => {
                                      edit_MeasurementSettingsDetails(
                                        measurement.measurementSettingsDetailsID_GUID,
                                        false
                                      );
                                    }}
                                    type="button"
                                    className="btn btn-light"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  &nbsp;
                                  <button
                                    onClick={() => {
                                      delete_MeasurementSettingsDetails(
                                        measurement.measurementSettingsDetailsID_GUID
                                      );
                                    }}
                                    type="button"
                                    className="btn btn-light"
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className="card-title"
                    style={{ marginBottom: "0px", height: "20px" }}
                  >
                    <div style={{ float: "left" }}>
                      {" "}
                      <h4>
                        {measurementSettings[0]?.name} - Measurement Atrributes
                        (Extra Note)
                      </h4>
                    </div>
                    <div style={{ float: "right" }}>
                      <button className="btn btn-primary px-3">Add New</button>
                    </div>
                    <div style={{ clear: "both" }}></div>
                    <hr />
                    <div style={{ clear: "both" }}></div>
                  </div>
                  <br /> <br />
                  {/* List Table //}
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>SI</th>
                          <th>Measurement Atrribute Name (Extra Note)</th>
                          <th>Type</th>
                          <th>Row</th>
                          <th>Column</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {measurementSettings
                          .filter((measurementDetail) => {
                            return measurementDetail.isNote === true;
                          })
                          .map((measurement, i) => {
                            return (
                              <tr>
                                <th>{i + 1}</th>
                                <td>{measurement.fieldName}</td>
                                <td>
                                  {measurement.fieldType == 1
                                    ? "Text"
                                    : "CheckBox"}
                                </td>
                                <td>{measurement.rowNo}</td>
                                <td>{measurement.columnNo}</td>
                                <td>
                                  <button
                                    onClick={() => {
                                      edit_MeasurementSettingsDetails(
                                        measurement.measurementSettingsDetailsID_GUID,
                                        true
                                      );
                                    }}
                                    type="button"
                                    className="btn btn-light"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  &nbsp;
                                  <button
                                    onClick={() => {
                                      delete_MeasurementSettingsDetails(
                                        measurement.measurementSettingsDetailsID_GUID
                                      );
                                    }}
                                    type="button"
                                    className="btn btn-light"
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </Fragment>
  );
};

export default ProductMeasurementSetting;
